import React from 'react';
import { Link } from 'react-router-dom';

const BlogPostCard = ({ post }) => {
    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    return (
        <Link
            to={`/blog/${post.slug}`}
            className="group block bg-white dark:bg-gray-800 p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 no-underline hover:no-underline border border-gray-100 dark:border-gray-700 h-full flex flex-col justify-between"
            style={{ textDecoration: 'none' }}
        >
            <div>
                <div className="flex justify-between items-start mb-6">
                    <div className="text-[10px] font-black uppercase tracking-widest text-[#1F7A8C] dark:text-[#BFDBF7] bg-[#1F7A8C]/10 dark:bg-white/5 px-3 py-1 rounded-full">
                        {post.tags?.[0] || 'Insight'}
                    </div>
                    <div className="text-gray-400 text-[10px] font-bold uppercase tracking-widest">
                        {formatDate(post.createdAt)}
                    </div>
                </div>

                <h3 className="text-2xl font-bold text-[#022B3A] dark:text-white mb-4 group-hover:text-[#1F7A8C] transition-colors leading-tight tracking-tight">
                    {post.title}
                </h3>

                <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed line-clamp-3 mb-6 font-medium">
                    {post.short_description || post.content.substring(0, 150) + '...'}
                </p>
            </div>

            <div className="flex items-center text-[#1F7A8C] dark:text-[#BFDBF7] text-xs font-black uppercase tracking-[0.15em] transition-all group-hover:translate-x-1">
                <span>Explore Full Guide</span>
                <span className="material-icons-outlined text-sm ml-2">arrow_forward</span>
            </div>
        </Link>
    );
};

export default BlogPostCard;
